<template>
  <div v-if="product.id==8" class="auth" style="padding-top: 0.88rem">
    <div class="banner">
        <div class="title1 wow animate__animated durationTime animate__fadeInUp">云计费认证系统</div>
        <div class="title2 wow animate__animated durationTime animate__fadeInUp">云端部署，SaaS服务，即开即用，专为场景营销运营而生</div>
    </div>
    <div class="line1">
      <div class="right">
        <div class="title wow animate__animated durationTime animate__fadeInUp">无限扩展的SaaS服务</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp" style="width: 5.98rem">
          SaaS化WiFi认证、计费和授权平台，实现了即开即用。突破了传统的用户扩容需要优先解决硬件性能的束缚，支持用户根据需求灵活扩容，这种灵活性不仅提升了管理效率，还确保了系统的持续扩展性，满足不断变化的业务需求。
        </div>
      </div>

    </div>
    <div class="line2">
      <div class="left">
        <div class="title wow animate__animated durationTime animate__fadeInUp">自主研发，全面掌控</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp" style="width: 6.88rem">
          我们平台的每一个组件，从BRAS网关到无线设备，均为自主研发。这种一体化的解决方案确保了系统的无缝集成，避免了不同厂商组件间的协调难题，为您提供了更高的控制力和适应性，让您在管理上更加得心应手。
        </div>
      </div>

    </div>
    <div class="line3">
      <div class="right">
        <div class="title wow animate__animated durationTime animate__fadeInUp">数据驱动，智慧营销</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp" style="width: 6.4rem">
          我们通过深入的多维度数据统计，为您提供决策支持。这些数据不仅帮助您洞察运营状况，还能助力您做出更明智的运营决策，提升业务效率，实现精准营销，从而推动业务的持续增长。
        </div>
      </div>
    </div>
    <div class="line4">
      <div class="left">
        <div class="title wow animate__animated durationTime animate__fadeInUp">用户导向，深入运营</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp" style="width: 6.56rem">
          我们不仅仅提供技术系统，更深入参与到用户的运营中。我们理解集成商和终端用户的需求，致力于提供定制化的解决方案，搭配高效的防共享系统，确保您的服务既安全又独特，满足市场和用户的特定需求。我们提供的不只是技术系统，更是深入参与到您的运营之中。
        </div>
      </div>

    </div>
  </div>
  <div v-else style="background-color: white;padding-top:0.88rem;">
    <div class="news-nav" id="news-nav">
      <div class="news-nav-pre cus-pointer" @click="jump('/')">
        首页
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-pre cus-pointer" @click="jump('/product')">
        产品中心
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-current">
        {{bigName}}
      </div>
    </div>
    <div class="product">
       <div class="left">
         <img class="wow animate__animated durationTime animate__fadeInUp" :style="{ width: productsDetail.img.w + 'rem' }" :src="require(`@/assets/${productsDetail.img.src}`)">
       </div>
      <div class="right">
        <div class="title wow animate__animated durationTime animate__fadeInUp">{{bigName}}</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp">
          {{productsDetail.desc}}
        </div>
        <div class="icon wow animate__animated durationTime animate__fadeInUp">
          <div class="item" v-for="item in productsDetail.icons">
            <div style="background-color: #FEF100;padding: 0.06rem;display: flex;justify-content: center;align-items: center;border-radius: 0.05rem;margin-right: 0.1rem">
              <img  :src="require(`@/assets/${item.src}`)">
            </div>
            <div class="text">
              {{item.title}}
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import productData from "./productsData.js";
import {WOW} from "wowjs";

export default {
  name: "partnerDetailSoft",
  metaInfo() {
    return {
      title: this.metaTitle, // 动态标题
    };
  },
  mounted() {
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true ,//异步加载的内容是否有效
    });
    wow.init();
  },
  data() {
    return {
      metaTitle:'',
      productsDetail: null,
      id:null,
      bigName:'',
      name:'',
      product:null,
    };
  },
  //为啥这里进来不是每次执行，在另外一个界面又是每次执行呢？
  // y:路由配置里面，不是每一项都要配置keepAlive:true的，默认不用去配置，当组件需要被缓存时再去配置
  created() {
    this.id=this.$route.query.id === undefined ? "1" : this.$route.query.id;
    this.handleData();
  },
  watch: {
    "$route.query.id": function(newVal) {
      this.id=newVal;
      this.handleData();
    }
  },
  computed: {

  },
  methods: {
    handleData() {
      this.product=null;
      let  products = productData.filter(v => this.id == v.id)[0];
      this.product=products;
      this.productsDetail=products.detail;
      this.bigName=products.name;
      this.metaTitle=this.bigName+"_柠檬网联";
    },
    handleDetail(id) {
      this.handleData(id);
    },
    goBack() {
      this.$router.go(-1);
    },
    jump(r) {
      this.$router.push({ path: r });
    },
  }
};
</script>
<style  scoped lang="scss">
.product{
  padding: 0.29rem 0 1rem 0rem;
  display: flex;
  .left{
    width: 50%;
    background: #F8FAFE;
    border-radius: 0  0.2rem   0.2rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.75rem 0;
  }
  .right{
    width: 50%;
    display: flex;
    padding: 0 2.18rem 0 1rem;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    .title{
      font-weight: 600;
      font-size: 0.34rem;
      color: #333333;
    }
    .desc{
      text-indent: 2em;
      font-weight: 400;
      font-size: 0.16rem;
      color: #333333;
      line-height: 0.35rem;
      margin-top: 0.2rem;
    }
    .icon{
      margin-top: 0.2rem;
      display: flex;
      flex-wrap: wrap;
      .item{
        display: flex;
        align-items: center;
        background-color: #FFF7EC;
        padding: 0.05rem 0.1rem;
        border-radius: 0.05rem;
        margin-right:0.2rem ;
        margin-top: 0.2rem;
        img{
          height: 0.18rem;
        }
        .text{
          font-weight: 500;
          font-size: 0.16rem;
          color: #3B5377;
        }
      }
    }
  }
}
.news-nav {
  padding: 0.29rem 0 0.29rem 2.18rem;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.news-prev > img,
.news-next > img,
.news-nav > img {
  width: 0.06rem;
  height: 0.12rem;
}
.news-nav > img {
  margin: 0 0.2rem;
}
.news-prev > img {
  margin-right: 0.1rem;
}
.news-next > img {
  margin-left: 0.1rem;
}
.news-nav-pre {
  font-size: 0.16rem;
  font-weight: 400;
  color: #999999;
}
.news-nav-current {
  height: 0.22rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
.auth{
  .banner{
    background: url('../../assets/image/product/auth1.jpg') center no-repeat;
    background-size: cover;
    padding: 2.39rem 0 2.26rem 1.8rem;
    .title1{
      font-weight: 500;
      font-size: 0.44rem;
      color: #333333;
    }
    .title2{
      font-weight: 400;
      font-size: 0.24rem;
      color: #333333;
      margin-top: 0.2rem;
    }
  }

  .right{
    position: absolute;
    top: 3.16rem;
    right: 2.36rem;
  }
  .left{
    position: absolute;
    top: 3.16rem;
    left: 2.36rem;
  }
  .title{
    font-weight: 600;
    font-size: 0.34rem;
    color: #333333;
  }
  .desc{
    font-weight: 400;
    font-size: 0.16rem;
    color: #333333;
    line-height: 0.35rem;
    margin-top: 0.4rem;
  }
  .line1{
    background: url('../../assets/image/product/auth2.jpg') center no-repeat;
    background-size: cover;
    height: 8.12rem;
    position: relative;
  }
  .line2{
    background: url('../../assets/image/product/auth3.jpg') center no-repeat;
    background-size: cover;
    height: 8.12rem;
    position: relative;
  }
  .line3{
    background: url('../../assets/image/product/auth4.jpg') center no-repeat;
    background-size: cover;
    height: 8.12rem;
    position: relative;
  }
  .line4{
    background: url('../../assets/image/product/auth5.jpg') center no-repeat;
    background-size: cover;
    height: 8.12rem;
    position: relative;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/product/productDetailSoft.vue